/* node_modules */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useIntl, defineMessages } from 'react-intl';
import { Formik, Form } from 'formik';

/* local imports */
import config from '~/config';
import { addFlash } from '~/modules/flashes';
import FormattedMessage from '~/components/common/FormattedMessage';
import TextField from '~/components/Form/TextField';
import Button from '~/components/Button';

/* style imports */
import styles from './ResendConfirmation.scss';

const ResendConfirmation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();

  const messages = defineMessages({
    success: {
      id: "ResendConfirmation_Sent",
      defaultMessage: "Confirmation Email sent"
    },
    failure: {
      id: "ResendConfirmation_NotFound",
      defaultMessage: "Email not found in records. Please sign up again",
    },
  });

  return <Formik
    initialValues={{
      email: ''
    }}
    onSubmit={({ email }) => {
      return fetch(`${config.api}/confirmation/new?email=${email}`, {
        method: 'POST',
      }).then(response => response.json())
        .then(response => {
          if (response.status === 'success') {
            dispatch(addFlash('success', intl.formatMessage(messages.success)));

            navigate('/login');
          } else {
            dispatch(addFlash('error', intl.formatMessage(messages.failure)));
          }
        });
    }}
  >
    <Form
      className={styles.ResendConfirmation}
    >
      <h2>
        <FormattedMessage
          id="ResendConfirmation_Heading"
          defaultMessage="Resend confirmation Email"
        />
      </h2>
      {status && (status === 'success' ? (
        <FormattedMessage
          id="ResendConfirmation_Sent"
          defaultMessage="Confirmation Email sent"
        />
      ) : (
        <FormattedMessage
          id="ResendConfirmation_NotFound"
          defaultMessage="Email not found in records. Please sign up again"
        />
      ))}
      <TextField
        name="email"
        placeholder="Enter your registered email address"
        fullWidth>
        <FormattedMessage
          id="ResendConfirmation_Email"
          defaultMessage="Email Address"
        />
      </TextField>
      <Button type="submit">
        <FormattedMessage
          id="ResendConfirmation_Submit"
          defaultMessage="Submit"
        />
      </Button>
    </Form>
  </Formik>
}

export default ResendConfirmation;
